export default {
    /** 공통 **/

    // 페이지 로딩 실패
    'page.loading.failure.title': '페이지 가져오기 실패',
    'page.loading.failure.desc.01': '페이지 로딩을 실패하였습니다.',
    'page.loading.failure.desc.02': '다시시도 혹은 새로고침 버튼을 클릭하여주세요.',

    // 페이지 찾기 실패
    'page.not.found.title': '죄송합니다. 페이지를 찾을 수 없습니다.',
    'page.not.found.desc.01': '존재하지 않는 주소를 입력하셨거나,',
    'page.not.found.desc.02': '요청하신 페이지의 주소가 변경, 삭제되어 찾을 수 없습니다.',

    // 페이지 에러 발생 (ex. 메일조회 시 뒷단에서 에러 발생)
    'page.error.desc': '다른 메뉴로 이동하시거나 새로고침 버튼을 클릭하여주세요.',

    // response error
    'response.error.400': '잘못된 요청입니다.',
    'response.error.404': '잘못된 요청입니다.',

    'response.error.520': '문서 분석을 위한 추출에 실패하였습니다.',
    'response.error.521': '문서 분석을 위한 추출에 실패하였습니다.',
    'response.error.522': '문서 분석을 위한 추출에 실패하였습니다.',

    'response.error.530': '데이터 저장소 서비스 접속을 실패하였습니다.',
    'response.error.531': '데이터 저장소에 저장을 실패하였습니다.',
    'response.error.532': '데이터 저장소에서 데이타를 가져오는데 실패하였습니다.',
    'response.error.533': '데이터 저장소에서 삭제를 실패하였습니다.',
    'response.error.534': '데이터 저장소에서 에러가 발생하였습니다.',
    'response.error.535': '데이터 저장소에서 사용할 수 없는 저장소 이름입니다.',
    'response.error.536': '데이터 저장소에서 에러가 발생하였습니다.',
    'response.error.537': '데이터 저장소에 저장을 실패하였습니다.',
    'response.error.538': '데이터 저장소에 저장을 실패하였습니다.',

    'response.error.550': '키워드 정보 추출 서비스 접속을 실패하였습니다.',
    'response.error.551': '키워드 정보 추출을 실패하였습니다.',
    'response.error.552': '키워드 정보 추출을 실패하였습니다.',

    'response.error.560': '지원하지 않는 파일 타입입니다.',
    'response.error.561': '이미지에서 문자 추출을 실패하였습니다.',

    'response.error.570': 'NER 정보 추출 서비스 접속을 실패하였습니다.',
    'response.error.571': 'NER 정보 추출을 실패하였습니다.',
    'response.error.572': 'NER 정보 추출을 실패하였습니다.',

    'response.error.580': '저장을 실패하였습니다.',
    'response.error.581': '저장을 실패하였습니다.',
    'response.error.582': '존재하지 않는 문서입니다.',
    'response.error.583': '삭제를 실패하였습니다.',// 실제로는 사용되지 않음

    'response.error.591': '허용된 파일 사이즈를 초과하였습니다.',
    'response.error.592': '삭제를 실패하였습니다.===',
    'response.error.593': '삭제 작업 중 {failCount}개를 실패하였습니다. ({successCount}개 삭제 성공)',

    
    // 기타 
    'common.add': '추가',
    'common.save': '저장',
    'common.cancel': '취소',
    'common.delete': '삭제',
    'common.modify': '수정',
    'common.refresh': '새로고침',
    'common.retry': '다시시도',
    'common.sort': '정렬',
    'common.search': '검색',
    'common.search.condition.add': '검색 조건 추가',
    'common.sidebar.open': '메뉴 열기',
    'common.sidebar.minimize': '메뉴 최소화',
    'common.sidebar.maximize': '메뉴 최대화',
    'common.list': '목록으로 돌아가기',
    'common.text.empty':'정보없음', // 링크가 걸려있는 곳에 출력할 데이타가 없을 때
    'common.pagination.first.page': '첫 페이지로 이동',
    'common.pagination.prev.page': '이전 페이지로 이동',
    'common.pagination.next.page': '다음 페이지로 이동',
    'common.pagination.last.page': '마지막 페이지로 이동',
    'common.save.success': '정상적으로 처리되었습니다.',
    'common.save.failure': '정보 저장에 실패하였습니다.',
    'common.delete.success': '삭제에 성공하였습니다.',
    'common.delete.failure': '삭제를 실패하였습니다.',
    'common.get.list.failure': '목록정보를 가져오는데 실패하였습니다.',
    'common.get.one.failure': '정보를 가져오는데 실패하였습니다.',
    'common.wrong.address': '이메일 형식이 아닙니다.',
    'common.search.count': '검색결과 {totalCount}',
    'common.data.empty': '데이터가 없습니다.',
    'common.search.empty': '검색 결과가 없습니다.',
    'common.form.required': '필수 입력 항목입니다.',
    'common.form.min.number': '최소 {min}{unit}부터 가능합니다.',
    'common.form.zero.and.positive.number': '0 또는 0보다 큰 숫자만 입력 가능합니다.',
    'common.form.number': '숫자를 입력하세요.',
    'common.form.min.length': '최소 {min}자 이상을 입력하세요.',
    'common.form.max.length': '최대 {max}자까지 입력 가능합니다.',
    'common.form.trim.min.length': '공백을 제외하고 최소 {min}자 이상을 입력하세요.',
    'common.form.max.value': '최대 {max}{unit}까지 가능합니다.',
    'common.name.invalid.characters': '\\ " 문자는 사용할 수 없습니다.',
    'common.wrong.period': '종료일이 시작일 이전으로 지정될 수 없습니다.',
    'common.copyright': 'Copyright © WESOME Co., Ltd. All rights reserved.',
    'common.move.prev.page': '이전 페이지로 이동',
    // webadmin
    'common.move.main.page': '메인 페이지로 이동',
    'common.wrong.fqdn': '도메인 형식이 잘못되었습니다.',
    'common.enabled': '사용',
    'common.disabled': '사용 안 함',
    'common.total': '총',
    'common.days.unit': '일',
    'common.count.unit': '개',
    'common.time.unit': '회',
    'common.metabytes.unit': 'MB',
    'common.gigabytes.unit': 'GB',
    'common.person.unit': '명',
    'common.percent.unit': '%',
    'common.form.number.integer': '정수값을 입력하세요.',
    'common.form.number.0_5': '0.5단위로 입력 가능합니다.',
    //
    'common.download.failure': '다운로드를 실패하였습니다.',
    'common.close': '닫기',
    /** //공통 **/

    
    /** 로그인/로그아웃 **/
    'product.name': 'SPIKE DOCUMENT',
    'lang.ko': '한국어',
    'lang.en': 'English',
    'lang.language': '언어',

    /** 헤더 **/
    'header.company.select': '회사 선택',
    'header.current.company': '현재 회사 : {name}',

    /** 메뉴명 **/
    'topmenu.document': 'SPIKE DOCUMENT',
    'sidebar.document.file': '문서 관리',
    'sidebar.document.graph.visualization': '문서 그래프 시각화',
    'sidebar.username': '{name}님',

    /** DatePicker **/
    'datepicker.today.button': '오늘로 입력',

    /** 문서 **/
    'spike.document.search.count': '검색결과 {totalCount}개',
    'spike.document.total.count': '총 {totalCount}개',
    'spike.document.file.date': '생성 시간',
    'spike.document.file.name': '파일 명',
    'spike.document.file.content': '본문',
    'spike.document.file.size': '파일 크기',
    'spike.document.file.type': '확장자',
    'spike.document.file.owner': '소유자',
    'spike.document.file.download': '파일 다운로드',
    'spike.document.file.tag': '키워드',
    'spike.document.file.location': '위치',
    'spike.document.file.person': '사람',
    'spike.document.file.oranization': '조직',

    'spike.document.empty': '등록된 문서가 없습니다..',

    // 삭제
    'document.file.delete.title': '문서 삭제',
    'document.file.delete.desc': '선택된 문서를 삭제하시겠습니까?',
    'document.file.delete.success': '{cnt}개의 문서가 삭제되었습니다.',

    /** 문서 검색 **/ 
    'document.search.file.name': '파일명 검색',
    'document.search.file.content': '본문 검색',
    'document.search.file.nameandcontent': '파일명 + 본문 검색',
    'document.search.file.tag': '키워드 검색',
    'document.search.file.owner': '소유자 검색',
    'document.search.startdate': '검색 시작일',
    'document.search.enddate': '검색 종료일',
    'document.search.file.person': '사람 검색',
    'document.search.file.organization': '회사 검색',
    'document.search.file.location': '위치 검색',

    /** 문서 메뉴 **/
    'document.menu.full.content': '전체 내용',
    'document.menu.simple.content': '검색관련 내용',
    'document.menu.prev': '이전 문서',
    'document.menu.next': '다음 문서',
    'document.menu.file.registration': '문서 등록',

    /** 문서 등록 **/
    'sidebar.document.file.registration': '문서 등록',
    'document.file.registration.subtitle': '파일 업로드를 통해 등록',
    'document.file.registration.file': '파일 (docx, doc, pptx, ppt, xlsx, xls, hwp, pdf, txt, png, bmp, gif, jpg 포맷만 지원함)',
    'document.file.tags': '키워드',
    'document.file.tags.input': '키워드를 입력하세요.',
    'document.file.tags.input.success': '키워드 추출을 성공하였습니다.',
    'document.file.tags.input.failure': '키워드 추출을 실패하였습니다.',
    'document.file.save': '파일 저장 여부',
    'document.file.save.on': '저장',
    'document.file.save.off': '저장 안 함',
    'document.bucket.name': '저장소 이름',
    'document.owner': '등록자 정보',
    'document.file.add': '문서 추가 및 업로드',
    'document.bucket.name.invalid': '영문, 숫자, -, .만 사용 가능하고, 기호는 맨 앞 혹은 맨 뒤에 사용할 수 없습니다.(3~32자리까지 가능합니다.)',

    /**** 비식별화 ****/
    'sidebar.document.deIdentification': '비식별화 처리',

    /** 문서 비식별화 **/
    'sidebar.document.file.deIdentification': '문서 비식별화',
    'document.file.deIdentification.subtitle': '문서에 포함된 개인정보를 비식별화 처리 한 뒤 저장',
    'document.file.deIdentification.file': '파일 (docx, doc, pptx, ppt, xlsx, xls, hwp, pdf 포맷만 지원함)',
    'document.file.deIdentification.basic.pattern': '기본 적용 패턴',
    'document.file.deIdentification.basic.pattern.01': '주민번호',
    'document.file.deIdentification.basic.pattern.02': '전화번호',
    'document.file.deIdentification.basic.pattern.03': '이메일',
    'document.file.deIdentification.basic.pattern.04': '여권번호',
    'document.file.deIdentification.custom.pattern': '사용자 지정 패턴',
    'document.file.deIdentification.custom.pattern.desc': '추가적인 비식별 패턴을 입력하세요. 입력하지 않으면 적용되지 않습니다.',
    'document.file.deIdentification.upload': '업로드',
    'document.file.deIdentification.download': '다운로드',

    /** 이미지파일 비식별화 */
    'sidebar.document.image.deIdentification': '이미지 비식별화',
    'document.image.deIdentification.subtitle': '이미지에 포함된 이메일정보를 비식별화 처리',
    'document.image.deIdentification.file': '파일 (png, bmp, gif, jpeg 포맷만 지원함)',
    'document.image.feature.type': '이미지 타입',
    'document.image.feature.type.document': '문서 이미지 (밀집된 텍스트 이미지)',
    'document.image.feature.type.image': '일반 이미지 (명함 등)',
    'document.image.languages': '언어',
    'document.image.languages.ko': '한국어',
    'document.image.languages.en': '영어',
    'document.image.source': '원본 이미지',
    'document.image.result': '결과 이미지',
    'document.image.deIdentification.upload': '이미지 비식별화 처리',

    /** 그래프 시각화 */
    'document.graph.visualization.subtitle': '검색을 통해 나온 결과를 더블클릭 하세요.',

    /** 이미지파일에서 지문 비식별화 */
    'sidebar.document.image.fingerprint.deIdentification': '문서 지문정보 비식별화',
    'document.image.fingerprint.deIdentification.subtitle': '문서안의 이미지로 저장된 지문정보 비식별화',
    'document.image.fingerprint.deIdentification.file': '문서내의 지원 이미지 포맷 (png, jpeg, bmp)',
    'document.image.fingerprint.deIdentification.help.desc.01': '신분증 또는 문서 이외의 이미지는 별도 학습을 통해서 비식별화가 가능합니다.',
    'document.image.fingerprint.deIdentification.help.desc.02': '현재는 문서내에 이미지에 대한 학습으로 Demo를 구현했습니다.',
    'document.image.fingerprint.deIdentification.upload': '지문정보 비식별화 처리',
    
    /** 공통 **/
    'common.file': '파일',
    'common.file.empty': '파일을 선택하세요.',
    'common.wrong.request': '잘못된 요청입니다.',// 필요한 정보들이 없을 때
    'common.spike.document.help.desc.01': '다양한 파일의 형식을 식별하고 TEXT추출이 가능한 SPFilter의 기능을 확인할 수 있습니다.',
    'common.spike.document.help.desc.02': '구조화 되지 않은 콘텐츠에서 가치있는 정보를 활용할 수 있게 필요한 데이터를 추출해 주는 역활을 확인할 수 있습니다.',
    'common.spike.document.help.desc.03': '전자메일 아카이브, 컨텐츠 관리, 개인정보 추출 및 비식별화, 비지니스 인텔리전스, Cognitive Search, Big Data 에 활용이 가능합니다.',

    /** dropzone **/
    'dropzone.file.select': '파일선택',
    'dropzone.file.drop': '파일을 놓으세요.',
    'dropzone.desc': '마우스로 파일을 끌어오거나, 버튼을 클릭하세요.',
    'dropzone.file.size.excess': '파일사이즈가 너무 큽니다. ({maxFilesize}MB 이하의 파일만 업로드할 수 있습니다.)',
    'dropzone.file.invalid.ext': '유효하지 않은 확장자입니다. ({fileExts} 확장자만 업로드할 수 있습니다.)',
}
